import React from "react";

export const editPenFilled = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9691 15.1263L17.0802 14.0014C17.2538 13.8257 17.5559 13.9487 17.5559 14.2018V19.3127C17.5559 20.2443 16.8093 21 15.8892 21H3.6667C2.74654 21 2 20.2443 2 19.3127V6.93956C2 6.00806 2.74654 5.25231 3.6667 5.25231H13.1634C13.41 5.25231 13.535 5.55461 13.3614 5.73388L12.2502 6.85871C12.1981 6.91144 12.1287 6.93956 12.0523 6.93956H3.6667V19.3127H15.8892V15.3231C15.8892 15.2493 15.917 15.179 15.9691 15.1263ZM21.4067 8.03276L12.2884 17.2634L9.14946 17.615C8.23972 17.7169 7.4654 16.94 7.56609 16.0121L7.91332 12.8344L17.0316 3.60372C17.8267 2.79876 19.1115 2.79876 19.9032 3.60372L21.4032 5.12225C22.1984 5.92721 22.1984 7.23131 21.4067 8.03276ZM17.976 9.11893L15.9586 7.07665L9.50711 13.6112L9.25363 15.9066L11.521 15.65L17.976 9.11893ZM20.2261 6.31739L18.7261 4.79886C18.5837 4.65474 18.351 4.65474 18.2122 4.79886L17.1392 5.88503L19.1566 7.92731L20.2296 6.84114C20.3685 6.6935 20.3685 6.4615 20.2261 6.31739Z"
        fill="currentColor"
      />
      <path d="M9 13L15.5 6L19 9.5L12 16.5H9V13Z" fill="currentColor" />
    </svg>
  );
};
